export default __webpack_public_path__ + "02ce913b97c0d8f90a6d542be286b64c.svg";